(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sa-ag-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
 const button=event.target.closest('[data-ag-filter]'); if(!button)return;
 const section=button.closest('.sa-ag-guide'); const group=button.dataset.agFilter;
 section.querySelectorAll('[data-ag-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 section.querySelectorAll('[data-ag-group]').forEach(card=>card.hidden=group!=='all'&&card.dataset.agGroup!==group);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-newsletter-klaviyo"] && !Shopify.designMode) return;
  try {
    
function saBindNewsletter(scope) {
  scope.querySelectorAll('[data-sa-newsletter]').forEach(form => {
    if (form.dataset.bound) return;
    form.dataset.bound = 'true';
    form.querySelector('button[type="submit"]').disabled = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (form.dataset.submitting === 'true') return;
      if (!form.reportValidity() || !form.querySelector('[data-consent-email]').checked) return;
      if (form.elements.sa_website.value) return;
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[role="status"]');
      const label = button.textContent;
      const email = form.elements.email.value.trim();
      const tracking = form.querySelector('[data-consent-tracking]').checked;
      const trackingConsent = tracking ? 'SUBSCRIBED' : 'UNSUBSCRIBED';
      const marketingText = form.querySelector('[data-consent-email]').nextElementSibling.textContent;
      const trackingText = form.querySelector('[data-consent-tracking]').nextElementSibling.textContent;
      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.source + ' / ' + form.dataset.version,
            profile: { data: { type: 'profile', attributes: {
              email,
              properties: {
                SA_newsletter_consent_version: form.dataset.version,
                SA_newsletter_consent_text: marketingText,
                SA_email_tracking_consent_text: trackingText,
                SA_email_tracking_choice: tracking,
                SA_newsletter_page: window.location.pathname,
                SA_newsletter_privacy_url: form.dataset.policy,
                SA_newsletter_consent_recorded_at: new Date().toISOString()
              },
              subscriptions: { email: {
                marketing: { consent: 'SUBSCRIBED' },
                open_tracking: { consent: trackingConsent },
                click_tracking: { consent: trackingConsent }
              } }
            } } }
          },
          relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
        }
      };
      form.dataset.submitting = 'true';
      button.disabled = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      form.setAttribute('aria-busy', 'true');
      status.hidden = true;
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(form.dataset.company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-10-15', accept: 'application/vnd.api+json' },
          body: JSON.stringify(body),
          signal: controller.signal
        });
        if (!response.ok) throw new Error('subscription_failed');
        status.textContent = form.dataset.success;
        status.dataset.error = 'false';
        form.reset();
      } catch {
        status.textContent = form.dataset.error;
        status.dataset.error = 'true';
      } finally {
        clearTimeout(timeout);
        delete form.dataset.submitting;
        status.hidden = false;
        button.disabled = false;
        button.textContent = label;
        form.removeAttribute('aria-busy');
      }
    });
  });
}
saBindNewsletter(document);
document.addEventListener('shopify:section:load', event => saBindNewsletter(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-rn-v11"]) return;
  try {
    
(function () {
  var formIds = ['richiesta-aziendale', 'richiesta-aziendale-bottom'];
  var payloadKey = 'sa_b2b_christmas_lead_payload';
  var queueKey = 'sa_b2b_christmas_confirmed_v2';
  var sentKey = 'sa_b2b_christmas_synced_v2';
  var trackingKey = 'sa_b2b_christmas_tracked_v2';
  var maxAge = 24 * 60 * 60 * 1000;
  var inFlight = false;
  var attempts = {};
  var retryTimer;

  function read(key, fallback) {
    try { return JSON.parse(window.sessionStorage.getItem(key)) || fallback; }
    catch (error) { return fallback; }
  }
  function save(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); return true; }
    catch (error) { return false; }
  }
  function remove(key) {
    try { window.sessionStorage.removeItem(key); } catch (error) {}
  }
  function fresh(p) {
    var age = p && Date.now() - Date.parse(p.capturedAt);
    return p && p.email && Number.isFinite(age) && age >= 0 && age < maxAge;
  }
  function newId() {
    return window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() :
      'sa-b2b-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }
  function value(form, name) {
    var field = form.querySelector('[name="contact[' + name + ']"]');
    return field && typeof field.value === 'string' ? field.value.trim() : '';
  }
  function queue() {
    var entries = read(queueKey, []);
    return Array.isArray(entries) ? entries.filter(function (p) { return fresh(p) && p.confirmed; }) : [];
  }
  function markState(state) {
    formIds.forEach(function (id) {
      var form = document.getElementById(id);
      if (form) form.setAttribute('data-sa-crm-state', state);
    });
  }
  function hiddenField(form, name, text) {
    var field = form.querySelector('[name="contact[' + name + ']"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'contact[' + name + ']';
      form.appendChild(field);
    }
    field.value = text;
  }

  save(queueKey, queue());
  if (!fresh(read(payloadKey, null))) remove(payloadKey);

  formIds.forEach(function (id) {
    var form = document.getElementById(id);
    if (!form || form.dataset.saLeadBound) return;
    form.dataset.saLeadBound = 'true';
    form.dataset.saLeadVersion = '2026-10-30-v2';
    form.addEventListener('submit', function (event) {
      var trap = form.querySelector('[name="website"]');
      if ((trap && trap.value) || !form.checkValidity()) {
        event.preventDefault();
        return;
      }
      var properties = {};
      new FormData(form).forEach(function (entry, key) {
        var match = /^contact\[(.+)\]$/.exec(key);
        if (match && typeof entry === 'string' && !['email', 'name', 'ID richiesta', 'Pagina origine'].includes(match[1])) {
          properties[match[1] === 'body' ? 'Messaggio' : match[1]] = entry.trim();
        }
      });
      var catalog = form.querySelector('[name="contact[Catalogo completo]"]');
      var p = {
        email: value(form, 'email'), name: value(form, 'name'),
        company: value(form, 'Azienda'), phone: value(form, 'Telefono'),
        quantity: value(form, 'Quantità'), budget: value(form, 'Budget'),
        catalog: !!(catalog && catalog.checked), properties: properties,
        formId: id, pagePath: window.location.pathname
      };
      var fingerprint = JSON.stringify(p);
      var previous = read(payloadKey, null);
      p.submissionId = fresh(previous) && previous.fingerprint === fingerprint ? previous.submissionId : newId();
      p.capturedAt = fresh(previous) && previous.fingerprint === fingerprint ? previous.capturedAt : new Date().toISOString();
      p.fingerprint = fingerprint;
      hiddenField(form, 'ID richiesta', p.submissionId);
      hiddenField(form, 'Pagina origine', p.pagePath);
      if (!save(payloadKey, p)) markState('storage-unavailable');
    });
  });

  document.addEventListener('click', function (event) {
    var copyButton = event.target.closest('[data-copy-email]');
    if (copyButton && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText('info@sicilyaddict.it').then(function () {
        var status = document.getElementById('sa-copy-status');
        if (status) {
          status.textContent = 'Email copiata: info@sicilyaddict.it';
          status.hidden = false;
          window.setTimeout(function () { status.hidden = true; }, 2200);
        }
      }).catch(function () {});
    }
    var infoLink = event.target.closest('[data-info]');
    if (infoLink) {
      var target = document.getElementById('info-' + infoLink.getAttribute('data-info'));
      if (target && target.tagName === 'DETAILS') target.open = true;
    }
  });

  function eventBody(p) {
    var properties = Object.assign({}, p.properties || {}, {
      'B2B Regali Aziendali Lead': true,
      'Lead Source': 'Landing Regali Aziendali Natale 2026',
      'Lead Captured At': p.capturedAt,
      'Catalogo richiesto': !!p.catalog,
      'Nome e cognome': p.name || '',
      'Azienda': p.company || '',
      'Telefono': p.phone || '',
      'Quantità': p.quantity || '',
      'Budget': p.budget || '',
      'ID richiesta': p.submissionId,
      'Page Path': p.pagePath,
      'Modulo': p.formId,
      'Shopify contact accepted': true
    });
    return { data: { type: 'event', attributes: {
      unique_id: p.submissionId,
      time: p.capturedAt,
      properties: Object.assign({}, properties, { 'Lead Type': 'B2B Regali Aziendali' }),
      metric: { data: { type: 'metric', attributes: { name: 'B2B Regali Aziendali - Lead' } } },
      profile: { data: { type: 'profile', attributes: {
        email: p.email, organization: p.company || '', properties: properties
      } } }
    } } };
  }

  function synchronize() {
    if (inFlight) return;
    var pending = queue();
    var p = pending.find(function (item) { return (attempts[item.submissionId] || 0) < 3; });
    if (!p) return;
    inFlight = true;
    attempts[p.submissionId] = (attempts[p.submissionId] || 0) + 1;
    markState('pending');
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
    fetch('https://a.klaviyo.com/client/events?company_id=N29gNf', {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', revision: '2026-10-15' },
      body: JSON.stringify(eventBody(p)), signal: controller.signal, credentials: 'omit'
    }).then(function (response) {
      if (response.status !== 202) {
        var error = new Error('crm_request_failed');
        error.retryable = response.status === 408 || response.status === 429 || response.status >= 500;
        throw error;
      }
      var sent = read(sentKey, []);
      if (!Array.isArray(sent)) sent = [];
      if (!sent.includes(p.submissionId)) sent.push(p.submissionId);
      save(sentKey, sent.slice(-30));
      save(queueKey, queue().filter(function (item) { return item.submissionId !== p.submissionId; }));
      markState(queue().length ? 'pending' : 'accepted');
    }).catch(function (error) {
      if (error.retryable === false) attempts[p.submissionId] = 3;
      markState('pending');
      console.warn('SicilyAddict: richiesta ricevuta da Shopify; sincronizzazione CRM in attesa.');
    }).finally(function () {
      window.clearTimeout(timeout);
      inFlight = false;
      window.clearTimeout(retryTimer);
      if (queue().length) retryTimer = window.setTimeout(synchronize, 3000);
    });
  }

  function trackLead(p) {
    var tracked = read(trackingKey, []);
    if (!Array.isArray(tracked)) tracked = [];
    if (tracked.includes(p.submissionId)) return;
    tracked.push(p.submissionId);
    save(trackingKey, tracked.slice(-30));
    var leadData = {
      lead_type: 'regali_aziendali_natale', lead_source: 'shopify_contact_form',
      page_path: p.pagePath, page_title: document.title, event_id: p.submissionId
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'generate_lead' }, leadData));
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('sa_b2b_generate_lead', leadData);
      }
    } catch (error) {}
    var metaSent = false;
    function sendMetaLead() {
      var allowed = false;
      try {
        allowed = !!(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.marketingAllowed());
      } catch (error) {}
      if (!metaSent && allowed && typeof window.fbq === 'function') {
        window.fbq('track', 'Lead', { content_name: 'Regali aziendali Natale 2026', content_category: 'B2B' }, { eventID: p.submissionId });
        metaSent = true;
      }
    }
    sendMetaLead();
    document.addEventListener('visitorConsentCollected', sendMetaLead);
    [1000, 3000, 8000].forEach(function (delay) { window.setTimeout(sendMetaLead, delay); });
  }

  var success = document.querySelector('[data-sa-native-success="true"]');
  if (success) {
    var p = read(payloadKey, null);
    if (fresh(p)) {
      p.submissionId = p.submissionId || newId();
      p.pagePath = p.pagePath || window.location.pathname;
      p.formId = p.formId || 'richiesta-aziendale';
      p.confirmed = true;
      var sent = read(sentKey, []);
      var pending = queue();
      if (!pending.some(function (item) { return item.submissionId === p.submissionId; }) && !sent.includes(p.submissionId)) pending.push(p);
      if (save(queueKey, pending)) remove(payloadKey);
      trackLead(p);
    } else if (!queue().length) {
      markState('no-pending-payload');
    }
    ['form-status', 'form-status-bottom'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) {
        el.textContent = 'Richiesta inviata correttamente. Il team SicilyAddict ti ricontatterà ai recapiti indicati.';
        el.hidden = false;
      }
    });
  }
  window.addEventListener('online', function () { attempts = {}; synchronize(); });
  synchronize();
})();


  } catch(e) { console.error(e); }
})();
})();
